<div class="loader-container" [attr.id]="embedded ? null : 'loader-container'" [class.show]="embedded">
    <div class="card">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">{{ message || 'Loading...' }}</span>
        </div>
        <fa-icon [icon]="faCheck" class="success-icon"></fa-icon>
        <fa-icon [icon]="faXmark" class="failure-icon"></fa-icon>
        <div class="loader-message" [attr.id]="embedded ? null : 'loader-message'">{{ message }}</div>
    </div>
</div>
